import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import { legalContent } from '../data/mock';
import '../styles/pages.css';
import usePageMeta from '../hooks/usePageMeta';

const Legal = () => {
  usePageMeta({
    title: 'Aviso Legal',
    description: 'Aviso legal y aviso de privacidad de SOEM Partners Group.',
    path: '/legal',
  });

  const [activeTab, setActiveTab] = useState('privacy');

  return (
    <Layout>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Aviso Legal</h1>
          <p>Información legal y políticas de privacidad</p>
        </div>
      </section>

      {/* Legal Content */}
      <section className="section">
        <div className="container">
          <div className="legal-container">
            {/* Tabs */}
            <div className="legal-tabs">
              <button
                className={`legal-tab ${activeTab === 'privacy' ? 'active' : ''}`}
                onClick={() => setActiveTab('privacy')}
              >
                Aviso de Privacidad
              </button>
              <button
                className={`legal-tab ${activeTab === 'terms' ? 'active' : ''}`}
                onClick={() => setActiveTab('terms')}
              >
                Términos de Uso
              </button>
            </div>

            {/* Content */}
            <div className="legal-content">
              {activeTab === 'privacy' && (
                <div className="legal-section">
                  <h2>{legalContent.privacy.title}</h2>
                  <div className="legal-text">
                    {legalContent.privacy.content.split('\n\n').map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                  <p className="legal-date">
                    Última actualización: Enero 2025
                  </p>
                </div>
              )}

              {activeTab === 'terms' && (
                <div className="legal-section">
                  <h2>{legalContent.terms.title}</h2>
                  <div className="legal-text">
                    {legalContent.terms.content.split('\n\n').map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                  <p className="legal-date">
                    Última actualización: Enero 2025
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Legal;
